import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const AppCalloutsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>AppCalloutsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(
            atlasRoutes.appCalloutsView({
              params: { appCalloutId: uuid },
            }).path
          )
        }
      />
    </div>
  );
};
